import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import api from '@home/api'
import * as accountType from '@account/store/types'
import * as dateutil from '@appbase/util/date-helper';
import VueAES from '@/modules/@appbase/util/vue-aes'


export interface codeLink extends home.link.Code{
  type:'award'|'slo'|'ezw'|'ehr'|'hunet'|'none'
  targetCom?: string[]
}

@Component({
  components:{
  },
  computed: mapGetters({
    user: accountType.USER,
    current: accountType.CURRENT

  })
})
export default class SystemQuickMenu extends Vue {

  user!: account.User
  current!:account.TCurrent
  group:string = 'PORTAL_MAIN_LINK'
  award:codeLink|null =null;
  linkList:codeLink[]=[];




  async clickIcon(link:codeLink){
    console.log(link.type);
    console.log(link);
    if(link.etcParam1==""){
      await (window as any).alertAsync('저장된 링크가 없습니다.')
      return
    }
    if(link.type == 'slo'){
      let moveTo = link.etcParam1
      var date = dateutil.uGetDateFormat('yyyyMMDDHi',new Date())
      var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
      var aes = new VueAES(this.current.key)
      moveTo += `?comCode=${this.current.user.comCode}&token=${encodeURIComponent(aes.encrypt(token))}`
      window.open(moveTo,'_blank','width=1000,height=700')
    }
    else if(link.type =='ezw'){
      let moveTo = link.etcParam1
      api.home.getEncryptedParam(this.current.user.personId).then(res=>{
        moveTo += `?D1=${encodeURIComponent(res.split('&')[0])}&clientInfo=${res.split('&')[1]}`
        window.open(moveTo)
      })
    }
    else if(link.type == 'ehr'){
      let moveTo = link.etcParam1
      var date = dateutil.uGetDateFormat('yyyyMMDDHis',new Date())
      var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
      var aes = new VueAES(this.current.key)
      moveTo += `?toke=${encodeURIComponent(aes.encrypt(token))}&page=HR340&languageCd=KOR`
      window.open(moveTo,'_blank','width=1000,height=700')
    }
    else if(link.type == 'hunet'){
      let moveTo = link.etcParam1
      var date = dateutil.uGetDateFormat('yyyyMMDDHis',new Date())
      var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
      var aes = new VueAES(this.current.key)
      moveTo += `?token=${encodeURIComponent(aes.encrypt(token))}`
      window.open(moveTo,'_blank','width=1000,height=700')
    }
    else{
      if(link.etcParam1.includes('vgmp.kolmar.')||link.etcParam1.includes('vgmpdev.kolmar.')){
        window.location.href = link.etcParam1;
      }
      else{
        window.open(link.etcParam1,'_blank','width=1100,height=800');
      }
    }
  }

  created(){
    api.home.getList(this.group).then(res=>{
      if(res){
        res.filter(r=>r.useYn).map(i=>{
          if(i.id==='award'){
            this.award = {...i,type:'award',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]}
          }
          else{
            if(i.id.startsWith('slo_')){
              this.linkList.push({...i,type:'slo',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]})
            }
            else if(i.id.startsWith('ezw_')){
              this.linkList.push({...i,type:'ezw',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]})
            }
            else if(i.id.startsWith('ehr_')){
              this.linkList.push({...i,type:'ehr',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]})
            }
           else if(i.id.startsWith('hunet_')){
              this.linkList.push({...i,type:'hunet',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]})
            }
            else{
              this.linkList.push({...i,type:'none',targetCom:i.etcParam2?i.etcParam2.toLowerCase().split(';').filter(i=>i!=''):[]})
            }
          }
        })
      }
    })

  }

  hknMall() {
    window.open('https://inno-n.ezwel.com/','_blank','width=1100,height=800');
  }

  hknSystem() {
    let moveTo = 'https://system.inno-n.com/sso/hknsystem.jsp';
    var date = dateutil.uGetDateFormat('yyyyMMDDHi',new Date())
    var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
    var aes = new VueAES(this.current.key)
    moveTo += `?comCode=${this.current.user.comCode}&token=${encodeURIComponent(aes.encrypt(token))}`
    window.open(moveTo,'_blank','width=1200,height=700')
  }
}